const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de almacen',
  PAGE_DESCRIPTION:
    'Este apartado muestra la informacion relevante del almacén actual. Desde aquí puedes gestionar distintas configuraciones del almacén, como: localizaciones, rangos de códigos postales y empaquetados (también recepción de empaquetados).',
  SETTINGS_DESCRIPTION_TITLE: 'Configuraciones del almacén',
  SETTINGS_DESCRIPTION:
    'Desde este apartado puedes Ver, Crear y Editar los siguientes atributos del almacén actual: ',
  LOCALIZATIONS_DESCRIPTION:
    'Las localizaciones son los espacios o "Bines" con los que cuenta el almacén actual.',
  PACKAGING_DESCRIPTION:
    'Los empaquetados son usados para la facturcion y el envío de todas las ordenes. La recepciones de empaquetado no son más que crear inventario para los empaquetados dados de alta.',
  ZIP_CODES_DESCRIPTION:
    'Los códigos postales en los que el almacén tiene rangos de envío'
};

export default HELPER_TEXTS;
